import { getColor } from '@assets/theme';
import {
  Box,
  CircularProgress,
  circularProgressClasses,
  CircularProgressProps,
  Dialog,
  Stack,
  Typography,
} from '@mui/material';

const FacebookCircularProgress = (props: CircularProgressProps) => {
  return (
    <Box sx={{ position: 'relative' }}>
      <CircularProgress
        variant='determinate'
        sx={(theme) => ({
          color: theme.palette.grey[200],
          ...theme.applyStyles('dark', {
            color: theme.palette.grey[800],
          }),
        })}
        size={40}
        thickness={4}
        {...props}
        value={100}
      />
      <CircularProgress
        variant='indeterminate'
        disableShrink
        sx={(theme) => ({
          animationDuration: '550ms',
          position: 'absolute',
          left: 0,
          [`& .${circularProgressClasses.circle}`]: {
            strokeLinecap: 'round',
          },
          ...theme.applyStyles('dark', {}),
        })}
        size={40}
        thickness={4}
        {...props}
      />
    </Box>
  );
};

const DialogLoading = ({
  isLoading,
  desc,
}: {
  isLoading: boolean;
  desc?: string;
}) => {
  const { secondary } = getColor();
  return (
    <Dialog open={isLoading}>
      <Stack
        sx={{
          py: 2,
          px: 3,
          justifyContent: 'center',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <FacebookCircularProgress />

        {desc && (
          <Typography sx={{ color: secondary, fontWeight: 300 }}>
            {desc}
          </Typography>
        )}
      </Stack>
    </Dialog>
  );
};

export default DialogLoading;
